import Cookies from "universal-cookie"
import axios from "axios"

const cookies = new Cookies()

// המפתחות שהאפליקציה עצמה שומרת ב-localStorage (מסכי התרגול והוידאו).
// מוחקים רק אותם ולא localStorage.clear(), כדי לא למחוק אחסון של צד שלישי —
// WonderPush מחזיק שם את מצב ההתקנה, ומחיקתו באמצע ניתוק עלולה להכשיל אותו.
const APP_STORAGE_KEYS = [
  'levelId', 'position', 'description', 'urlVideo', 'urlImage',
  'type', 'TimeVideo', 'success', 'techName', 'execiserId',
]

let onSessionExpired = null

// AuthProvider נרשם כאן, כדי שה-interceptor יוכל לדווח על פקיעת סשן
// בלי לנווט בעצמו (ניווט קשיח הורג פקודות WonderPush שטרם יצאו).
export function setSessionExpiredHandler(handler) {
  onSessionExpired = handler
}

export function notifySessionExpired() {
  if (onSessionExpired) {
    onSessionExpired()
    return
  }
  // אף אחד לא נרשם (שגיאה עוד לפני ש-AuthProvider עלה) — לא משאירים את המשתמש תקוע
  clearSession()
  window.location.href = '/'
}

// ניקוי כל שאריות הסשן המקומיות.
// נקרא גם מ-logout וגם ממסלול פקיעת הסשן, כדי ששני המסלולים ינקו בדיוק אותו דבר.
export function clearSession() {
  cookies.remove('bezkoder-jwt-refresh', { path: '/' })
  cookies.remove('wonderPush_token', { path: '/' })
  cookies.remove('isProfilePassed', { path: '/' })
  cookies.remove('groupType', { path: '/' })
  axios.defaults.headers.common['Authorization'] = null
  APP_STORAGE_KEYS.forEach(key => localStorage.removeItem(key))
}
